

exports.__esModule = true;
exports.$fiApis = undefined;

var _angular = require('angular');

var $fiApis = exports.$fiApis = {
    patchCvv: function patchCvv(checkoutSession) {
        var cvvData = checkoutSession.get('cvvData');

        if (cvvData) {
            return checkoutSession.action('patchCvv', {
                data: {
                    id: cvvData.id,
                    cvv: cvvData.security_code,
                    type: cvvData.type,
                    number: cvvData.number
                }
            });
        }

        return _angular.$q.when();
    }
};

angular.value("$fiApis", $fiApis);
_angular.$q;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/fi/lib/fiApis.js
// module id = ../node_modules/xo-models/src/fi/lib/fiApis.js
// module chunks = 0